import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const MyTableRow = ({ columns, spacing }) => {
  const heading = (labelId, i) => (
    <Grid key={`myTableRow-${i}`} item xs={12}>
      <Typography variant="subtitle1" color="textPrimary">
        <FormattedMessage id={labelId} />
      </Typography>
    </Grid>
  );

  const oneColumn = (children, i) => (
    <Grid key={`myTableRow-${i}`} item xs={12}>
      {children}
    </Grid>
  );

  const twoColumns = (labelId, content, colOne = 3, colTwo = 9, i) => (
    <Grid key={`myTableRow-${i}`} container item xs={12}>
      <Grid item xs={12} sm={colOne}>
        {
        !labelId ? '' : (
          <Typography variant="subtitle2" color="textSecondary">
            <FormattedMessage id={labelId} />
          </Typography>
        )
      }
      </Grid>
      <Grid item xs={12} sm={colTwo}>
        {content}
      </Grid>
    </Grid>
  );

  const details = columns.map((col, i) => {
    if (col.hide) return '';

    switch (col.type) {
      case 'heading':
        return heading(col.labelId, i);
      case 'oneColumn':
        return oneColumn(col.content, i);
      case 'twoColumns':
        return twoColumns(col.labelId, col.content, col.colOne, col.colTwo, i);
      default:
        return '';
    }
  });

  return (
    <Grid container spacing={spacing}>
      {details}
    </Grid>
  );
};

const myTableRowPropTypes = PropTypes.shape({
  hide: PropTypes.bool,
  type: PropTypes.oneOf(['heading', 'oneColumn', 'twoColumns']),
  content: PropTypes.element,
  colOne: PropTypes.number,
  colTwo: PropTypes.number,
});

MyTableRow.propTypes = {
  columns: PropTypes.arrayOf(myTableRowPropTypes),
  spacing: PropTypes.number,
};

MyTableRow.defaultProps = {
  columns: [],
  spacing: 1,
};

export default MyTableRow;
